export default __webpack_public_path__ + "static/media/a037-student-t3-2.2febe1c1.svg";